import ACTIONS, { FETCH_STATUS } from "../constants";

export const getJourneySessions = {
  pending: { type: ACTIONS.JOURNEY_SESSIONS_LIST.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.JOURNEY_SESSIONS_LIST.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.JOURNEY_SESSIONS_LIST.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getJourneySessionsRequest = (payload) => ({
  type: ACTIONS.JOURNEY_SESSIONS_LIST_CALL,
  payload,
});

export const getJourneySessionDetail = {
  pending: (payload) => ({
    type: ACTIONS.JOURNEY_SESSION_DETAIL.PENDING,
    payload,
    status: FETCH_STATUS.LOADING,
  }),
  success: (data) => ({ type: ACTIONS.JOURNEY_SESSION_DETAIL.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.JOURNEY_SESSION_DETAIL.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getJourneySessionDetailRequest = (payload) => ({
  type: ACTIONS.JOURNEY_SESSION_DETAIL_CALL,
  payload,
});

export const getJourneyActiveUsers = {
  pending: { type: ACTIONS.JOURNEY_ACTIVE_USERS.PENDING, status: FETCH_STATUS.LOADING },
  success: (data) => ({ type: ACTIONS.JOURNEY_ACTIVE_USERS.SUCCESS, data, status: FETCH_STATUS.SUCCESS }),
  error: (error) => ({ type: ACTIONS.JOURNEY_ACTIVE_USERS.ERROR, error, status: FETCH_STATUS.ERROR }),
};

export const getJourneyActiveUsersRequest = (payload) => ({
  type: ACTIONS.JOURNEY_ACTIVE_USERS_CALL,
  payload,
});

export const resetJourneySessionDetail = () => ({
  type: ACTIONS.RESET_JOURNEY_SESSION_DETAIL,
});
